import { CreateSalesTaxPaymentParams, SalesTaxPayment } from '../../../commonTypes/SalesTaxPaymentTypes'
import beam from './beam'

export const getSalesTaxPaymentsByOrganization = (organizationId:string) => beam.get<SalesTaxPayment[]>(`/api/organizations/${organizationId}/salesTaxPayments`)

export const createSalesTaxPayment = (params:CreateSalesTaxPaymentParams) => beam.post<SalesTaxPayment>(`/api/organizations/${params.organization}/salesTaxPayments`, params)

export const deleteSalesTaxPayment = (salesTaxPaymentId:string) => beam.del(`/api/salesTaxPayments/${salesTaxPaymentId}`)
